module.exports = __webpack_public_path__ + "img/Recurso 11.6331ca06.png";